var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidden({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 47,
    viewBox: "0 0 54 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55 3.1L5.65 0L48.7 43.05L45.6 46.15C45.2 45.75 44 44.6 42 42.6C40 40.65 38.45 39.1 37.4 38.05C34.15 39.45 30.6 40.15 26.8 40.15C20.8 40.15 15.35 38.5 10.5 35.15C5.65 31.8 2.15 27.4 0 21.95C0.85 19.9 2.15 17.75 3.95 15.35C5.75 12.95 7.45 11.1 9.15 9.85C8.25 8.9 6.95 7.6 5.3 5.95C3.7 4.3 2.75 3.35 2.55 3.1ZM15.95 16.55C15.05 18.35 14.6 20.15 14.6 21.9C14.6 25.25 15.8 28.1 18.2 30.5C20.6 32.9 23.45 34.1 26.8 34.1C28.55 34.1 30.35 33.65 32.15 32.75L28.4 29C27.8 29.1 27.25 29.2 26.8 29.2C24.8 29.2 23.1 28.5 21.65 27.05C20.25 25.6 19.5 23.9 19.5 21.9C19.5 21.45 19.6 20.9 19.75 20.3L15.95 16.55ZM26.8 9.7C25.3 9.7 23.8 10 22.35 10.6L17.1 5.4C20.1 4.25 23.3 3.65 26.8 3.65C32.8 3.65 38.2 5.3 43.05 8.65C47.85 12 51.35 16.4 53.45 21.85C51.6 26.35 48.85 30.15 45.15 33.35L38.1 26.3C38.7 24.85 39 23.4 39 21.85C39 18.5 37.8 15.65 35.4 13.25C33 10.85 30.15 9.7 26.8 9.7ZM26.45 14.6H26.8C28.75 14.6 30.5 15.3 31.95 16.75C33.35 18.2 34.1 19.9 34.1 21.9V22.35L26.45 14.6Z",
    fill: "#292B5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default __webpack_public_path__ + "static/media/hidden.6d2b98348c89c5d1827ab0c338a5605f.svg";
export { ForwardRef as ReactComponent };